
export type State = {
  isThreeMode: boolean
  isRenderingMode: boolean
}

export const state: State = {
  isThreeMode: false,
  isRenderingMode: false
};
